// extracted by mini-css-extract-plugin
export default {"transfer-form":"file-transfer__transfer-form","spinner":"file-transfer__spinner","button":"file-transfer__button"};